import { useEffect } from 'react';
import type { ShogunChopDaemonNotice } from '@localagent/sdk';
import { useShogunchop } from '../../providers/ShogunChopProvider';
import { showDaemonNoticeToast, shouldShowDaemonNotice } from './daemon-notices';

/**
 * Desktop-only subscriber for daemon-originated notices (la ADR-016).
 *
 * Mounted app-wide beside `NotificationToastDispatcher`, and deliberately NOT
 * merged with it: that pipeline is backend-originated and rides the cloud
 * bridge, while this rides the daemon's authenticated loopback `/events`.
 * A web tab has no daemon, so the effect returns before opening anything.
 */
export function DaemonNoticeDispatcher(): null {
  const shogunchop = useShogunchop();

  useEffect(() => {
    const sc = shogunchop.resource;
    if (!sc) return;

    const relay = sc.sharedEvents();

    relay.on((event) => {
      if (event.event !== 'daemon:notice') return;
      const notice = event.data as ShogunChopDaemonNotice;
      if (!shouldShowDaemonNotice(notice)) return;
      showDaemonNoticeToast(notice);
    });

    return () => {
      relay.release();
    };
  }, [shogunchop.resource]);

  return null;
}
